module.exports = __webpack_public_path__ + "img/taco.13a150fb.svg";